import React, { useEffect } from "react";

// hooks
import { useRedux } from "../../../hooks/index";
import { createSelector } from "reselect";
// components
import Loader from "../../../components/Loader";
import AppSimpleBar from "../../../components/AppSimpleBar";
import MyProfile from "./MyProfile";
import UserDescription from "./UserDescription";
import Media from "../../../components/Media";
import AttachedFiles from "../../../components/AttachedFiles";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";


import { getCurrentUserAction } from "../../../redux/profile2/p2_reducer";

// actions
import { getProfileDetails } from "../../../redux/actions";
import UserGroups from "components/UserGroups";

interface IndexProps { }
const Index = (props: IndexProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();
  const navigate = useNavigate();


  const errorData = createSelector(
    (state: any) => state.Profile,
    (profile2: any) => profile2.Profile2,
    (state, profile2) => ({
      profileDetails: state.profileDetails,
      getProfileLoading: state.getProfileLoading,
      isProfileFetched: state.isProfileFetched,

      profile2: profile2
    })
  );
  // Inside your component
  const { profileDetails, getProfileLoading, isProfileFetched, profile2 } = useAppSelector(errorData);
  // console.log('UserProfileLeft.profile2:', profile2);

  // get user profile details
  useEffect(() => {
    // dispatch(getProfileDetails());

    // console.log('Get Current User From Server');
    dispatch(getCurrentUserAction());
  }, [dispatch]);

  useEffect(() => {
    // if (profile2.online === false){
    //   navigate("/auth-login");
    // }
    //console.log('useEffect.profile2.online', profile2.online);
  }, [profile2]);

  return (
    <div className="position-relative">
      {getProfileLoading && !isProfileFetched && <Loader />}
      {/* <MyProfile basicDetails={profileDetails.basicDetails} /> */}
      <MyProfile basicDetails={profile2.basicDetails}  />

      <AppSimpleBar className="p-4 profile-desc">
        <UserDescription basicDetails={profileDetails.basicDetails} />
        <hr className="my-3" />

        <UserGroups />
        <hr className="my-3" />

        {/* <Media media={profileDetails.media} limit={2} />
        <hr className="my-4" /> */}

        {/* <AttachedFiles attachedFiles={profileDetails.attachedFiles} /> */}
      </AppSimpleBar>
    </div>
  );
};

export default Index;
